import { Button, Popconfirm, Tag } from "antd";
import { CHANNEL_LABELS } from "../../const";

export const getMappingColumns = ({ handleEdit, handleDelete }) => {
  return [
    {
      title: "Channel",
      dataIndex: "channel",
      key: "channel",
      render: (channel) => CHANNEL_LABELS[channel] || channel,
    },
    {
      title: "Room",
      dataIndex: "room",
      key: "room",
      render: (room) => room?.name || "—",
    },
    {
      title: "Rate Plan",
      dataIndex: "ratePlan",
      key: "ratePlan",
      render: (ratePlan) => ratePlan?.rateplanname || "—",
    },
    {
      title: "SiteMinder InvTypeCode",
      dataIndex: "roomTypeCode",
      key: "roomTypeCode",
    },
    {
      title: "SiteMinder RatePlanCode",
      dataIndex: "ratePlanCode",
      key: "ratePlanCode",
    },
    {
      title: "Occupancy",
      dataIndex: "includedAdultOccupancy",
      key: "includedAdultOccupancy",
    },
    {
      title: "Rate Setup",
      dataIndex: "rateSetupType",
      key: "rateSetupType",
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (active) => (
        <Tag color={active ? "green" : "default"}>{active ? "Active" : "Inactive"}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <Button onClick={() => handleEdit(record)} type="primary" style={{ marginRight: 8 }}>
            Edit
          </Button>
          <Popconfirm
            title="Delete this mapping?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
};
